'use es6';

import { createSelector } from 'reselect';
import { getEntries } from 'conversations-async-data/indexed-async-data/operators/getters';
import { getFocusedThreadVisitorId } from '../../visitor/selectors/getFocusedThreadVisitorId';
import { getIndexedAsyncVisitors } from 'conversations-thread-data/visitor/selectors/getIndexedAsyncVisitors';
import getIn from 'transmute/getIn';
export const getIsCurrentVisitorAContactAssociatedToCurrentThread = createSelector([getFocusedThreadVisitorId, getIndexedAsyncVisitors], (threadVisitorId, asyncVisitors) => {
  return getIn([`${threadVisitorId}`, 'data', 'contact'], getEntries(asyncVisitors));
});